import ButtonPrimary from "componentsTemplate/Button/ButtonPrimary";
import Layout from "./layout";
import LayoutDashboard from "./layout/layout";
import Table from "components/table/table";
import { useCallback, useEffect, useState } from "react";
import PerfilService from "../../services/PerfilService";
import { useNavigate, useParams } from "react-router-dom";
import AttachmentsPosts from "./AttachmentsPosts";
import FormFieldInput from "components/campos/input";
import FormFieldTextArea from "components/campos/textarea";
import FormFieldFileInput from "components/campos/file";
import FormFieldSelect from "components/campos/select";
import canaisService from "../../services/CanaisService";
import ClassifiedsService from "../../services/ClassifiedsService";
import { toast } from "react-toastify";
import FormFieldSwith from "components/campos/FormFieldSwith";
import * as Yup from 'yup';
import AddressFields from "./AddressFields";
import { get } from "services/post/ClassifiedService";

const ClassifiedsCreateOrEdit = () => {
  const [errors, setErrors] = useState<Record<string, string>>({});
  const [functionPage, setFunctionPage] = useState('create');
  const [user, setUser] = useState({} as any);
  const [loading, setLoading] = useState(false);

  const [subCategoriesBase, setSubCategoriesBase]       = useState([]);
  const [categoriesOptions, setCategoriesOptions]       = useState([]);
  const [subCategoriesOptions, setSubCategoriesOptions] = useState([]);
  const [groupCitiesOptions, setGroupCitiesOptions]     = useState([]);

  const [showAddressFields, setShowAddressFields] = useState(true); 

  const [componentKey, setComponentKey] = useState(0);

  const [dados, setDados] = useState(null);
  const [anexos, setAnexos] = useState([]);

  // pegando o parametro da url
  const { id } = useParams();
  const navigate = useNavigate();

  const validationSchema = Yup.object().shape({
    classified: Yup.object().shape({
      category_id: Yup.string().required('Categoria é obrigatória'),
      subcategory_id: Yup.string().required('Subcategoria é obrigatória'),
      name: Yup.string().required('Título é obrigatório'),
      description: Yup.string().required('Descrição é obrigatória'),
      hasnt_address: Yup.boolean().nullable(),
      currency_id: Yup.string().required('Moeda é obrigatória'),
      value: Yup.string().required('Valor é obrigatório'),
    }),
    post: Yup.object().shape({
      group_city_id: Yup.string().required('Grupo de cidades é obrigatório'),
    }),
  });

  const setNestedValue = (object: any, path: string, value: any) => {
    const keys = path.split(".");
    const lastKey: any = keys.pop();
    const lastObj = keys.reduce((obj, key) => {
      if (!obj[key]) obj[key] = {};
      return obj[key];
    }, object);
    lastObj[lastKey] = value;
  };
  
  const useForm = (initialState: any) => {
    const [formData, setFormData] = useState(initialState);
  
    const handleChange = (fieldName: string, value: any) => {
      setFormData((prevData: any) => {
        const newData = { ...prevData };
        setNestedValue(newData, fieldName, value);
    
        // Atualiza a visibilidade dos campos de endereço
        if (fieldName === "classified.hasnt_address") {
          setShowAddressFields(!value); // Inverte o valor (true/false)
        }
    
        return newData;
      });
    };
  
    return { formData, handleChange };
  };

  const { formData, handleChange } = useForm({
    classified: {
      category_id: "",
      subcategory_id: "",
      name: "",
      description: "",
      currency_id: "",
      hasnt_address: false,
    },
    address: {
      country: "",
      state: "",
      city: "",
      postal_code: "",
      address: "",
      number: "",
      district: "",
      complement: "",
    },
    post: {
      group_city_id: "",
    },
  });

  useEffect(() => {
    if (id) {
      setFunctionPage('edit');
    }
  }, [id]);

  useEffect(() => {
    if (dados) {

      handleChange("classified.category_id", dados?.category_id);
      setSubCategoriesOptions(subCategoriesBase.filter((item: any) => item.category_id == dados?.category_id));      

      handleChange("classified.category_id", dados?.category_id);
      handleChange("classified.subcategory_id", dados?.subcategory_id);
      handleChange("classified.name", dados?.name);
      handleChange("classified.description", dados?.description);
      handleChange("classified.hasnt_address", dados?.hasnt_address);
      handleChange("classified.currency_id", dados?.currency_id);
      handleChange("classified.value", dados?.value);
  
      if (dados?.address) {
        handleChange("address.country", dados?.address?.country);
        handleChange("address.state", dados?.address?.state);
        handleChange("address.city", dados?.address?.city);
        handleChange("address.postal_code", dados?.address?.postal_code);
        handleChange("address.address", dados?.address?.address);
        handleChange("address.number", dados?.address?.number);
        handleChange("address.district", dados?.address?.district);
        handleChange("address.complement", dados?.address?.complement);
      }
  
      handleChange("post.group_city_id", dados?.post?.group_city_id);

      setAnexos(dados.attachments);

      // 🔹 Atualiza a key para forçar re-renderização
      setComponentKey((prevKey) => prevKey + 1);
    }
  }, [dados]);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      await getUser();
      await getCanais(4);
      if (id) {
        await getClassified(id);
      }
    }
    fetchData();
  }, []);

  const getClassified = async (itemId : any) => {
    await get(itemId)
      .then((response: any) => {
        if (response.data) {
          setDados(response.data);
  
          if(response.data.address == null){
            handleChange("classified.hasnt_address", true);
            setShowAddressFields(false);
          }
        }
      })
      .catch((error: any) => {
        console.error(error);
      });
  }

  const getUser = async () => {
    await PerfilService.getUser()
      .then((response: any) => {
        setUser(response.data.user);
      })
      .catch((error: any) => {
        console.error(error);
      })
      .finally(() => {
       //setLoading(false); // end loading
      });
  };

  const getCanais = async (idTipo: any) => {
    await canaisService
      .getCanais(idTipo, "")
      .then((response: any) => {

        const categories = response.categories.map((item: any) => {
          return { value: item.id, label: item.name };
        });

        const subcategories = response.subcategories.map((item: any) => {
          return { value: item.id, label: item.name, category_id: item.category_id };
        });

        const groupCities = response.group_cities.map((item: any) => {
          return { value: item.id, label: item.name };
        });

        groupCities.sort((a: any, b: any) => a.label.localeCompare(b.label));

        setCategoriesOptions(categories);
        setGroupCitiesOptions(groupCities);
        setSubCategoriesOptions(subcategories);

        setSubCategoriesBase(subcategories);
      })
      .catch((error: any) => {
        console.error(error);
      })
      .finally(() => {
        setLoading(false); // end loading
      });
  };

  const submit = async () => {

    try {
      // Valida o formulário
      await validationSchema.validate(formData, { abortEarly: false });

      // Verificando manualmente se os campos de endereço são obrigatórios - se hasnt_address for false pais e estado somente
      if (!formData.classified.hasnt_address) {
        if (!formData.address.country) {
          toast.error('País é obrigatório');
          setErrors({ ...errors, 'address.country': 'País é obrigatório caso declare endereço' });
          return;
        }
        if (!formData.address.state) {
          toast.error('Estado é obrigatório');
          setErrors({ ...errors, 'address.state': 'Estado é obrigatório caso declare endereço' });
          return;
        }
      }

      // Se a validação passar, prossegue com o envio
      let newDados: any = {
        classified: {
          category_id: formData.classified.category_id,
          subcategory_id: formData.classified.subcategory_id,
          name: formData.classified.name,
          description: formData.classified.description,
          currency_id: formData.classified.currency_id,
          value: formData.classified.value,
          hasnt_address: formData.classified.hasnt_address,
        },
        post: {
          group_city_id: formData.post.group_city_id,
        },
      };
  
      if (!formData.classified.hasnt_address) {
        newDados.address = {
          country: formData.address.country,
          state: formData.address.state,
          city: formData.address.city,
          postal_code: formData.address.postal_code,
          address: formData.address.address,
          number: formData.address.number,
          district: formData.address.district,
          complement: formData.address.complement,
        };
      }
  
      let response: any;
      if (id) {
        response = await ClassifiedsService.update(id, newDados);
      } else {
        response = await ClassifiedsService.post(newDados);
      }
  
      toast.success('Classificado salva com sucesso!');
      navigate('/meus-classificados');

    } catch (error : any) {

      if (error instanceof Yup.ValidationError) {
        // Exibe os erros de validação
        const errors = error.inner.reduce((acc, curr) => {
          acc[curr.path] = curr.message;
          return acc;
        }, {} as Record<string, string>);
  
        setErrors(errors);

        // Exibe o primeiro erro encontrado
        const firstError = Object.values(errors)[0];
        toast.error(firstError);

      } else {
       //informa o primeiro erro retornado considerando que o backend é em laravel com um arquivo de request
       toast.error(error.response.data.errors[Object.keys(error.response.data.errors)[0]][0]);
      }
    }
  };

  const optionsMoeda = [
    { value: "1", label: "Real" },
    { value: "2", label: "Dolar" },
    { value: "3", label: "Euro" },
  ];

  const handleCategoryChange = useCallback((categoryId: any) => {
    if (categoryId) {
      setSubCategoriesOptions(subCategoriesBase.filter((item: any) => item.category_id == categoryId)); 
    } else {
      setSubCategoriesOptions([]);
    }
    handleChange("classified.subcategory_id", "");
  }, [subCategoriesBase]);

  return (
    <Layout user={user}>
      <LayoutDashboard>
      <>
        <div className="flex-end">
          <ButtonPrimary
            className="md:col-span-2"
            type="button"
            onClick={() => navigate('/meus-classificados')}
          >
            Voltar
          </ButtonPrimary>
        </div>
        <br />

        {
          loading ? (
            <div>
              <div className="spinner border-primary-600 my-20"></div>
            </div>
          ) : (
            <div className="rounded-xl md:border md:border-neutral-100 dark:border-neutral-800 md:p-6">
              {dados != null && <AttachmentsPosts tipoTela={2} dados={dados} anexos={anexos} setAnexos={setAnexos} />}
    
              <form className="grid md:grid-cols-2 gap-6" action="#" method="post">

                <FormFieldSelect
                  key={'category_id_' + componentKey}
                  label={'Categoria'}
                  fieldName={'classified.category_id'}
                  options={categoriesOptions}
                  formData={formData}
                  handleChange={handleChange}
                  action={handleCategoryChange}
                  error={errors['classified.category_id']}
                />
    
                <FormFieldSelect
                  key={'subcategory_id'}
                  label={'Subcategoria'}
                  fieldName={'classified.subcategory_id'}
                  options={subCategoriesOptions}
                  formData={formData}
                  handleChange={handleChange}
                  error={errors['classified.subcategory_id']}
                />
    
                <FormFieldInput
                  key={"name"}
                  label={"Título"}
                  fieldName={"classified.name"}
                  type={"text"}
                  formData={formData}
                  handleChange={handleChange}
                  classe={"md:col-span-2"}
                  error={errors['classified.name']}
                />
    
                <FormFieldTextArea
                  key={"description"}
                  label={"Descrição"}
                  fieldName={"classified.description"}
                  extraProps={{ rows: 8, mdColSpan: 2 }}
                  formData={formData}
                  handleChange={handleChange}
                  error={errors['classified.description']}
                />

                <FormFieldSelect
                  key={'currency_id'}
                  label={'Moeda'}
                  fieldName={'classified.currency_id'}
                  options={optionsMoeda}
                  formData={formData}
                  handleChange={handleChange}
                  // action={groupCitiesOptions}
                  error={errors['classified.currency_id']}
                />

                <FormFieldInput
                  key={"value"}
                  label={"Valor"}
                  fieldName={"classified.value"}
                  type={"text"}
                  formData={formData}
                  handleChange={handleChange}
                  error={errors['classified.value']}
                />
    
                <FormFieldSelect
                  key={"group_city_id"}
                  label={"Grupo de Cidades"}
                  fieldName={"post.group_city_id"}
                  options={groupCitiesOptions}
                  formData={formData}
                  handleChange={handleChange}
                  classe={"md:col-span-2"}
                  error={errors['post.group_city_id']}
                />
    
                <hr className="mt-5 col-span-1 md:col-span-2" />
    
                <FormFieldSwith 
                  label={"Essa dica não possui endereço ?"} 
                  fieldName={"classified.hasnt_address"} 
                  formData={formData} 
                  handleChange={handleChange} 
                  classe={"md:col-span-2"}
                  error={errors['classified.hasnt_address']}
                />
                
                <div
                  className={`col-span-1 md:col-span-2 transition-all duration-300 ease-in-out ${
                    showAddressFields
                      ? "opacity-100 max-h-[1000px] overflow-visible"
                      : "opacity-0 max-h-0 overflow-hidden"
                  }`}
                >
                  <AddressFields formData={formData} handleChange={handleChange} errors={errors} />
                </div>
  
    
                <ButtonPrimary
                  className="md:col-span-2"
                  type="button"
                  onClick={submit}
                >
                  {functionPage == 'create' ? 'Salvar' : 'Editar'}
                </ButtonPrimary>
              </form>
            </div>
          )
        }

      </>
      </LayoutDashboard>
    </Layout>
  );
};

export default ClassifiedsCreateOrEdit;
